import React from "react";
import Modal from "react-bootstrap/Modal";

const LocationModal = ({
  show,
  onClose,
  locationName,
  setLocationDetails,
  locationError,
  onSubmit,
  disableSubmit,
}) => {

  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Add Project Location</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="input-block local-forms">
          <label>
            Location <span className="login-danger">*</span>
          </label>
          <input
            className="form-control"
            type="text"
            value={locationName}
            onChange={(e) => setLocationDetails(e.target.value)}
            placeholder="Enter Location Details"
          />

          {locationError && (
            <div className="error text-danger mt-1">{locationError}</div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={onSubmit}
          disabled={disableSubmit}
        >
          {disableSubmit ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default LocationModal;
